export interface IFollowUpDonorForList {
    id: number,
    centerId: number,
    centerAlias: string,
    firstName: string,
    lastName: string,
    genderId: number,
    gender: string,
    birthDate: string,
    city: string,
    stateId: number,
    state: string,
    donationDate: string,
    lastSurveyInstanceId: number,
    lastSurveyInstance: string,
    nextSurveyInstanceId: number,
    nextSurveyInstance: string,
    nextSurveyDate: string
}